import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { useTitledRoutes } from './useTitledRoutes';

const ROOT_TITLE = 'Trident - Envirosuite';

export function useBrowserTitle() {
    const { pathname } = useLocation();
    const titledRoutes = useTitledRoutes();

    useEffect(() => {
        const matchedRoute = titledRoutes.find(({ path }) => matchPath(path, pathname));
        document.title = matchedRoute ? `${matchedRoute.title} - ${ROOT_TITLE}` : ROOT_TITLE;
    }, [pathname, titledRoutes]);
}
